import { render, staticRenderFns } from "./Assistants.vue?vue&type=template&id=7c4b5435&"
import script from "./Assistants.vue?vue&type=script&lang=js&"
export * from "./Assistants.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports